

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import { ERecipientStatus } from '@lib-shared/recipients/types/enums/recipient-status';
import { throttle } from '@lib-shared/helpers';
import type { IDocument } from '@signing-page/documents/types/document';
import type { IRecipient } from '@signing-page/documents/types/recipient';
import type { IEntity } from '@signing-page/entity/types/entity';
import type { IUser } from '@signing-page/users/types/user';

@Component({
  data: () => ({
    EButtonType,
  }),
})
export default class ApproveModal extends Vue {
  @Prop() document!: IDocument;
  @Prop() entity!: IEntity;
  @Prop() sender!: IUser;
  @Prop() recipient!: IRecipient;
  @Prop() authId!: string;

  @Watch('recipient.status')
  approved() {
    if (this.recipient.status === ERecipientStatus.Approved) {
      this.handleClose();
    }
  }

  handleClose(): void {
    this.$emit('close');
  }

  handleApprove = throttle(this.emitApprove, 1000);

  emitApprove() {
    this.$emit('approve');
  }
}
